import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { HOLE_WH_COEFF, EFFECTIVE_COEFF } from '../../constants';

export const Canvas = ({ videoParams, setCtx }) => {
  const canvasRef = useRef();
  const canvasWindth = window.innerWidth;
  const canvasHeight = canvasWindth * HOLE_WH_COEFF;
  useEffect(() => {
    if (!videoParams) return;
    console.log('[Canvas]', { videoParams });
    const canvas = canvasRef.current;
    canvas.width = canvasWindth;
    canvas.height = canvasHeight;
    const context = canvas.getContext('2d');
    context.translate(canvas.width, 0);
    context.scale(-1, 1);
    context.setTransform(1, 0, 0, 1, 0, 0);
    let effectiveWidth = canvasWindth * EFFECTIVE_COEFF;
    let effectiveHeight = canvasHeight * EFFECTIVE_COEFF;
    // console.log('[Canvas]', canvas.width, canvasWindth, effectiveWidth);

    if (effectiveHeight > videoParams.videoHeight) {
      // console.warn(`effectiveHeight > videoParams.videoHeight
      // ${effectiveHeight} ${videoParams.videoHeight}`);
      const coeff = effectiveHeight / videoParams.videoHeight;
      effectiveHeight = videoParams.videoHeight;
      effectiveWidth /= coeff;
    }
    if (effectiveWidth > videoParams.videoWidth) {
      // console.warn(`effectiveWidth > videoParams.videoWidth
      // ${effectiveWidth} ${videoParams.videoWidth}`);
      const coeff = effectiveWidth / videoParams.videoWidth;
      effectiveWidth = videoParams.videoWidth;
      effectiveHeight /= coeff;
    }
    const effectiveX = (videoParams.videoWidth - effectiveWidth) / 2;
    const effectiveY = (videoParams.videoHeight - effectiveHeight) / 2;
    context.width = canvasWindth;
    context.height = canvasHeight;
    context.effectiveX = effectiveX;
    context.effectiveY = effectiveY;
    context.effectiveWidth = effectiveWidth;
    // console.log('[Canvas]', context.effectiveWidth, effectiveWidth);
    context.effectiveHeight = effectiveHeight;
    setCtx(context);
    // eslint-disable-next-line
  }, [videoParams, setCtx]);
  // console.log('[Canvas].render', {
  //   canvasWindth,
  //   canvasHeight,
  // });

  return (
    <>
      <canvas
        id="canvas"
        ref={canvasRef}
        style={{
          // border: '1px solid blue',
          position: 'fixed',
          left: 0,
          width: `${canvasWindth}px`,
          height: `${canvasHeight}px`,
          WebkitTransform: 'scaleX(-1)',
          transform: 'scaleX(-1) translate(0, -50%)',
          top: 'calc(50vh - 50px)',
        }}
      />
    </>
  );
};

Canvas.propTypes = {
  videoParams: PropTypes.object.isRequired,
  setCtx: PropTypes.func.isRequired,
};
